var _Path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgMobilityAndTone(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M15.489 8.7a3.166 3.166 0 10-.056-6.331 3.166 3.166 0 00.056 6.33zM26.73 26.839l-8.283-7.278V13.86h6.029c.787 0 1.439-.652 1.439-1.44 0-.787-.652-1.439-1.44-1.439l-18.057.028c-.788 0-1.44.651-1.44 1.439 0 .787.652 1.439 1.44 1.439h5.892v5.73l-2.932 2.77a1.662 1.662 0 00-.516 1.303l.244 4.48a1.662 1.662 0 001.656 1.548h.11a1.641 1.641 0 001.547-1.738l-.217-3.693 3.204-2.987s6.497 5.709 9.124 8.01c.326.272.706.408 1.086.408.462 0 .923-.19 1.25-.57a1.633 1.633 0 00-.136-2.308z"
  })));
}

export default SvgMobilityAndTone;